/**
 * @generated SignedSource<<0ae4916b3f7d5e56a591c7ac97a591cf>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeletependingsubscriptionPayload",
    "kind": "LinkedField",
    "name": "deletependingsubscription",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "integer",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DeletePendingSubscriptionMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DeletePendingSubscriptionMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "6c672ea9ad1f210b3f03ec05d59220de",
    "id": null,
    "metadata": {},
    "name": "DeletePendingSubscriptionMutation",
    "operationKind": "mutation",
    "text": "mutation DeletePendingSubscriptionMutation(\n  $input: DeletependingsubscriptionInput!\n) {\n  deletependingsubscription(input: $input) {\n    integer\n  }\n}\n"
  }
};
})();

node.hash = "5b6e45363c54ef2183022815f0ea1b5d";

module.exports = node;
